import React from 'react';
import { useSelector, useDispatch } from "react-redux";

import ButtonIcon from '../common/ButtonIcon';
import IconNew from '../svg/IconNew';
import CreateRoom from './modals/CreateRoom';
import CustomNoSubscription from './modals/CustomNoSubscription';

import {
  setModal
} from "../../../actions/index";

function ButtonStart() {
  const dispatch = useDispatch();
  const isSubscribed = useSelector( state => state.isSubscribed);
  const onClick = async () => {
    dispatch(setModal({
      content: isSubscribed ? <CreateRoom /> : <CustomNoSubscription />,
      underlayClickExits: false
    }));
  }
  return <ButtonIcon className={`b-p`} style={{ width: 120, padding: '0px' }}
    icon={<IconNew />}
    label={'Create Set'}
    classNameLabel={`brand-primary type-medium fz13`}
    onClick={onClick}
  />
}

export default ButtonStart;
